import script from "./view_ficha_jornada.vue?vue&type=script&setup=true&lang=js"
export * from "./view_ficha_jornada.vue?vue&type=script&setup=true&lang=js"

import "./view_ficha_jornada.vue?vue&type=style&index=0&id=15345964&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15345964"]])

export default __exports__